export default __webpack_public_path__ + "static/media/coffee.f9d9dd9e.svg";